module.exports = __webpack_public_path__ + "media/shared/arrow_triangle-8611ba9b.svg";